export default [
  {
    path: '/app/teams',
    name: 'Teams',
    component: () => import('@/views/Admin/Teams/Index.vue'),
    meta: {
      pageTitle: 'Ekibimiz',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_TEAMS',
      action: 'read',
    },
  },
  {
    path: '/app/teams/add',
    name: 'TeamAdd',
    component: () => import('@/views/Admin/Teams/Add.vue'),
    meta: {
      pageTitle: 'Ekibimiz',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/teams',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_TEAMS',
      action: 'read',
    },
  },
  {
    path: '/app/teams/edit/:id',
    name: 'TeamEdit',
    component: () => import('@/views/Admin/Teams/Edit.vue'),
    meta: {
      pageTitle: 'Ekibimiz',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/teams',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_TEAMS',
      action: 'read',
    },
  },
]
